export default function connectWebsocket(url, timeout) {
  return new Promise((resolve, reject) => {
    const ws = new WebSocket(url);

    const timer = setTimeout(() => {
      ws.onopen = null;
      ws.onerror = null;
      ws.close();

      reject(
        new Error(`WebSocket connection timeout after ${timeout}ms to ${url}`),
      );
    }, timeout);

    ws.onerror = (event) => {
      ws.onopen = null;
      ws.onerror = null;
      ws.close();
      clearTimeout(timer);

      // Create a more descriptive error from the event
      const error = new Error(`WebSocket connection error to ${url}`);
      error.name = "WebSocketError";
      error.event = event;
      error.url = url;
      error.readyState = ws.readyState;

      // Map readyState to human-readable values
      const readyStateMap = {
        0: "CONNECTING",
        1: "OPEN",
        2: "CLOSING",
        3: "CLOSED",
      };
      error.readyStateText =
        readyStateMap[ws.readyState] || `UNKNOWN(${ws.readyState})`;

      reject(error);
    };

    ws.onopen = () => {
      ws.onopen = null;
      ws.onerror = null;
      clearTimeout(timer);

      resolve(ws);
    };
  });
}
